<!-- Register route: path: '/org/:sub_level/:id/fund-collection/:type/inspection-report', component: InspectionReport -->
<template>
    <div class="section text-center mt-4" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <template v-else>
        <div class="section pt-2">
            <div class="isr-hero">
                <h3 class="isr-hero-title mal-text">ഇൻസ്പെക്ഷൻ റിപ്പോർട്ട്</h3>
                <div class="isr-hero-meta mal-text" v-if="zoneName">{{ zoneName }}</div>
                <div class="isr-hero-summary mal-text" v-if="units.length">
                    {{ completedCount }} / {{ units.length }} ശാഖകളിൽ പൂർത്തിയായി
                </div>
            </div>
        </div>

        <div class="section pt-0 mt-2" v-if="!units.length">
            <div class="isr-empty mal-text">ഡാറ്റ ലഭ്യമല്ല</div>
        </div>

        <div class="section pt-0 mt-2" v-else>
            <div class="isr-card">
                <div class="isr-unit-wrap" v-for="unit in units" :key="unit.unit_id">
                    <a href="javascript:void(0)" class="isr-unit-row"
                        @click="unit.completed ? toggleExpand(unit.unit_id) : null">
                        <span class="isr-unit-name mal-text">{{ unit.unit_name }}</span>
                        <span class="isr-badge" :class="unit.completed ? 'done' : 'pending'">
                            {{ unit.completed ? 'പൂർത്തിയായി' : 'ബാക്കി' }}
                        </span>
                        <ion-icon v-if="unit.completed" name="chevron-down-outline" class="isr-chevron"
                            :class="{ open: expanded === unit.unit_id }"></ion-icon>
                    </a>

                    <div class="isr-detail" v-if="unit.completed && expanded === unit.unit_id">
                        <div class="isr-meta mal-text" v-if="unit.inspected_by_name">
                            {{ unit.inspected_by_name }} · {{ unit.inspected_at }}
                        </div>
                        <div class="isr-qa-row" v-for="q in inspectionQuestions" :key="q.key">
                            <span class="isr-qa-label mal-text">{{ q.label }}</span>
                            <span class="isr-qa-answer" :class="unit.answers[q.key] ? 'yes' : 'no'">
                                {{ unit.answers[q.key] ? 'അതെ' : 'ഇല്ല' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

const INSPECTION_QUESTIONS = [
    { key: "a", label: "യൂണിറ്റിൽ Accounts book ഉണ്ടോ?" },
    { key: "b", label: "Book കൃത്യമായി എഴുതുന്നുണ്ടോ?" },
    { key: "c", label: "ഓരോ മാസവും ബാലൻസ് ചെയ്ത് സെക്രട്ടറി / പ്രസിഡന്റ് ഒപ്പ് വെച്ചിട്ടുണ്ടോ?" },
    { key: "d", label: "സംഭാവനകൾക്ക് Receipt നൽകിയിട്ടുണ്ടോ?" },
    { key: "e", label: "Income Expense Voucher സൂക്ഷിച്ചിട്ടുണ്ടോ?" },
    { key: "f", label: "ബില്ലുകൾ Voucher-മായി ഒട്ടിച്ചു ചേർത്ത് വെച്ചിട്ടുണ്ടോ?" },
    { key: "g", label: "ഫണ്ടിൽ നിന്നും ലഭിച്ച പണം അതത് ആവശ്യത്തിന് മാത്രമാണോ ഉപയോഗിച്ചത്?" },
    { key: "h", label: "Receivables and Payables രേഖപ്പെടുത്തി വെച്ചിട്ടുണ്ടോ?" },
];

export default {
    name: "InspectionReport",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            zoneName: "",
            units: [],
            inspectionQuestions: INSPECTION_QUESTIONS,
            expanded: null,
            alert_type: "",
            alert_message: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        completedCount() {
            return this.units.filter((u) => u.completed).length;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("ഇൻസ്പെക്ഷൻ റിപ്പോർട്ട്");
        this.loadReport();
    },
    methods: {
        showAlert(type, message) {
            this.alert_type = type;
            this.alert_message = message;
            this.$refs.alert_model.openModel();
        },
        toggleExpand(unitId) {
            this.expanded = this.expanded === unitId ? null : unitId;
        },
        loadReport() {
            this.loading = true;
            UserService.authPostRequest("receipt-book/take-back/inspection-report", {
                zone_id: parseInt(this.$route.params.id, 10),
                fund_type: this.$route.params.type,
                year: new Date().getFullYear(),
            }).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    this.zoneName = response.data.data.zone ? response.data.data.zone.name : "";
                    this.units = response.data.data.units || [];
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.loading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
    },
};
</script>

<style scoped>
.isr-hero {
    background: #fff;
    border-radius: 14px;
    padding: 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.isr-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a418c;
}
.isr-hero-meta {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}
.isr-hero-summary {
    font-size: 0.85rem;
    font-weight: 700;
    color: #12a85a;
    margin-top: 6px;
}
.isr-empty {
    text-align: center;
    color: #6c757d;
    padding: 20px 0;
}
.isr-card {
    background: #fff;
    border-radius: 14px;
    padding: 4px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.isr-unit-wrap {
    border-top: 1px solid #f3f4f8;
}
.isr-unit-wrap:first-child { border-top: none; }
.isr-unit-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
    text-decoration: none;
}
.isr-unit-name {
    flex: 1;
    min-width: 0;
    font-size: 13.5px;
    font-weight: 700;
    color: #27173E;
}
.isr-badge {
    flex-shrink: 0;
    font-size: 10.5px;
    font-weight: 700;
    border-radius: 20px;
    padding: 3px 10px;
    white-space: nowrap;
}
.isr-badge.done { background: #eafaf1; color: #12a85a; }
.isr-badge.pending { background: #fff5f5; color: #d9534f; }
.isr-chevron {
    flex-shrink: 0;
    font-size: 16px;
    color: #94a3b8;
    transition: transform .2s ease;
}
.isr-chevron.open { transform: rotate(180deg); }
.isr-detail {
    padding: 0 0 12px;
}
.isr-meta {
    font-size: 11px;
    color: #6c757d;
    margin-bottom: 8px;
}
.isr-qa-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
    border-top: 1px solid #f8f9fb;
}
.isr-qa-row:first-of-type { border-top: none; }
.isr-qa-label {
    font-size: 11.5px;
    color: #475569;
    line-height: 1.35;
}
.isr-qa-answer {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 6px;
}
.isr-qa-answer.yes { background: #eafaf1; color: #12a85a; }
.isr-qa-answer.no { background: #fff5f5; color: #d9534f; }
</style>
